import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from "../../assets/Configuration";
import { TenantUpdateModel } from '../models/tenants/tenant-update.model';
import { UnregisteredRoleModel } from '../models/settings/unregistered-role.model';
import { TenantModel } from '../models/tenants/tenant.model';

@Injectable({
    providedIn: 'root',
})
export class GeneralSettingsService {

    private httpClientWithoutInterceptor: HttpClient;

    constructor(private httpClient: HttpClient, private httpBackend: HttpBackend) {
        this.httpClientWithoutInterceptor = new HttpClient(httpBackend);
    }

    public getTenant(): Observable<TenantModel> {
        return this.httpClient.get<TenantModel>(
            Configuration.getApiBaseUrl() + '/tenant'
        );
    }

    public getUnregisteredPersons(): Observable<UnregisteredRoleModel[]> {
        return this.httpClient.get<UnregisteredRoleModel[]>(
            Configuration.getApiBaseUrl() + '/tenant/unregistered-persons'
        );
    }

    public isExternalCertificateApprovalEnabled(): Observable<boolean> {
        return this.httpClient.get<boolean>(Configuration.getApiBaseUrl() + '/tenant/external-certificate-approval/enabled');
    }

    public getTenantDomains(): Observable<string[]> {
        return this.httpClient.get<string[]>(Configuration.getApiBaseUrl() + '/tenant/domains');
    }

    public updateSettings(settingsModel: TenantUpdateModel): Observable<TenantModel> {
        return this.httpClient.post<TenantModel>(Configuration.getApiBaseUrl() + '/tenant', settingsModel);
    }

    public getLoginImage(loginAlias: string): Observable<string> {
        const params = new HttpParams()
            .set('alias', loginAlias);
        
        return this.httpClientWithoutInterceptor.get<string>(
            Configuration.getApiBaseUrl() + '/tenantanonymous/login-image-by-alias',
            {
                responseType: 'text' as 'json',
                params: params
            }
        );
    }
}
